(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-icon-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("custom-icon-slider");
  const allSlides = Array.from(document.querySelectorAll(".custom-icon-slide"));
  const dotsContainer = document.querySelector(".custom-icon-pagination");
  const left = document.querySelector(".custom-icon-arrow.left");
  const right = document.querySelector(".custom-icon-arrow.right");

  if (!slider || allSlides.length === 0) return;

  let index = 0;
  let visibleCount = window.innerWidth >= 900 ? 4 : 1;
  let groups = [];

  function groupSlides() {
    // Reset slider
    slider.innerHTML = "";
    dotsContainer.innerHTML = "";

    visibleCount = window.innerWidth >= 900 ? 4 : 1;
    const totalGroups = Math.ceil(allSlides.length / visibleCount);
    groups = [];

    for (let i = 0; i < totalGroups; i++) {
      const group = document.createElement("div");
      group.className = "custom-icon-group";
      const start = i * visibleCount;
      const end = start + visibleCount;
      allSlides.slice(start, end).forEach(slide => group.appendChild(slide.cloneNode(true)));
      slider.appendChild(group);
      groups.push(group);
    }

    for (let i = 0; i < totalGroups; i++) {
      const dot = document.createElement("span");
      dot.className = "custom-icon-dot";
      if (i === index) dot.classList.add("active");
      dot.addEventListener("click", () => updateSlider(i));
      dotsContainer.appendChild(dot);
    }

    updateSlider(index);
  }

  function updateSlider(i) {
    const totalGroups = groups.length;
    index = (i + totalGroups) % totalGroups;
    slider.style.transform = `translateX(-${index * 100}%)`;

    groups.forEach((g, i) => {
      g.style.justifyContent = (i === index && g.children.length < visibleCount) ? "center" : "flex-start";
    });

    document.querySelectorAll(".custom-icon-dot").forEach((dot, idx) => {
      dot.classList.toggle("active", idx === index);
    });
  }

  left?.addEventListener("click", () => updateSlider(index - 1));
  right?.addEventListener("click", () => updateSlider(index + 1));

  setInterval(() => {
      updateSlider(index + 1);
  }, 5000);

  // Initial load
  groupSlides();

  // Rebuild on resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      index = 0;
      groupSlides();
    }, 300);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-logos-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".custom-logos-footer-slider");
  const slides = document.querySelectorAll(".custom-logos-footer-slide");
  const dotsContainer = document.querySelector(".custom-logos-footer-pagination");
  const left = document.querySelector(".custom-logos-footer-arrow.left");
  const right = document.querySelector(".custom-logos-footer-arrow.right");

  if (!track || slides.length === 0) return;

  let index = 0;

  function updateSlider(i) {
    if (!track) return;
    index = (i + slides.length) % slides.length;
    track.style.transform = `translateX(-${index * 100}%)`;

    document.querySelectorAll(".custom-logos-footer-dot").forEach((dot, idx) => {
      dot.classList.toggle("active", idx === index);
    });
  }

  // dots
  slides.forEach((_, i) => {
    const dot = document.createElement("span");
    dot.className = "custom-logos-footer-dot";
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => updateSlider(i));
    dotsContainer?.appendChild(dot);
  });

  left?.addEventListener("click", () => updateSlider(index - 1));
  right?.addEventListener("click", () => updateSlider(index + 1));

  // autoplay
  setInterval(() => {
    if (window.innerWidth < 900) {
      updateSlider(index + 1);
    }
  }, 5000);

  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;

  track.addEventListener("mousedown", dragStart);
  track.addEventListener("touchstart", dragStart);

  track.addEventListener("mouseup", dragEnd);
  track.addEventListener("touchend", dragEnd);

  track.addEventListener("mousemove", dragMove);
  track.addEventListener("touchmove", dragMove);

  function dragStart(e) {
    if (window.innerWidth >= 900) return; // désactive sur desktop
    isDragging = true;
    startX = getPositionX(e);
    animationID = requestAnimationFrame(animation);
    track.style.transition = "none";
  }

  function dragMove(e) {
    if (!isDragging) return;
    const currentX = getPositionX(e);
    const deltaX = currentX - startX;
    currentTranslate = prevTranslate + deltaX;
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    cancelAnimationFrame(animationID);

    const movedBy = currentTranslate - prevTranslate;

    if (movedBy < -50) {
      updateSlider(index + 1);
    } else if (movedBy > 50) {
      updateSlider(index - 1);
    } else {
      updateSlider(index); // reste au même slide
    }
  }

  function getPositionX(e) {
    return e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
  }

  function animation() {
    track.style.transform = `translateX(${currentTranslate}px)`;
    if (isDragging) requestAnimationFrame(animation);
  }

  function updateSlider(i) {
    index = (i + slides.length) % slides.length;
    currentTranslate = -index * track.offsetWidth;
    prevTranslate = currentTranslate;
    track.style.transition = "transform 0.3s ease-out";
    track.style.transform = `translateX(${currentTranslate}px)`;

    document.querySelectorAll(".custom-logos-footer-dot").forEach((dot, idx) => {
      dot.classList.toggle("active", idx === index);
    });
  }
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-with-icon"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".feature-slider");
  const slides = document.querySelectorAll(".feature-slide");
  const dotsContainer = document.querySelector(".feature-pagination");
  const left = document.querySelector(".feature-arrow.left");
  const right = document.querySelector(".feature-arrow.right");

  if (!track || slides.length === 0) return;

  let index = 0;

  function updateSlider(i) {
    if (!track) return;
    index = (i + slides.length) % slides.length;
    track.style.transform = `translateX(-${index * 100}%)`;

    document.querySelectorAll(".feature-dot").forEach((dot, idx) => {
      dot.classList.toggle("active", idx === index);
    });
  }

  // dots
  slides.forEach((_, i) => {
    const dot = document.createElement("span");
    dot.className = "feature-dot";
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => updateSlider(i));
    dotsContainer?.appendChild(dot);
  });

  left?.addEventListener("click", () => updateSlider(index - 1));
  right?.addEventListener("click", () => updateSlider(index + 1));

  // autoplay
  setInterval(() => {
    if (window.innerWidth < 900) {
      updateSlider(index + 1);
    }
  }, 5000);

  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;

  track.addEventListener("mousedown", dragStart);
  track.addEventListener("touchstart", dragStart);

  track.addEventListener("mouseup", dragEnd);
  track.addEventListener("touchend", dragEnd);

  track.addEventListener("mousemove", dragMove);
  track.addEventListener("touchmove", dragMove);

  function dragStart(e) {
    if (window.innerWidth >= 900) return; // désactive sur desktop
    isDragging = true;
    startX = getPositionX(e);
    animationID = requestAnimationFrame(animation);
    track.style.transition = "none";
  }

  function dragMove(e) {
    if (!isDragging) return;
    const currentX = getPositionX(e);
    const deltaX = currentX - startX;
    currentTranslate = prevTranslate + deltaX;
  }

  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;
    cancelAnimationFrame(animationID);

    const movedBy = currentTranslate - prevTranslate;

    if (movedBy < -50) {
      updateSlider(index + 1);
    } else if (movedBy > 50) {
      updateSlider(index - 1);
    } else {
      updateSlider(index); // reste au même slide
    }
  }

  function getPositionX(e) {
    return e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
  }

  function animation() {
    track.style.transform = `translateX(${currentTranslate}px)`;
    if (isDragging) requestAnimationFrame(animation);
  }

  function updateSlider(i) {
    index = (i + slides.length) % slides.length;
    currentTranslate = -index * track.offsetWidth;
    prevTranslate = currentTranslate;
    track.style.transition = "transform 0.3s ease-out";
    track.style.transform = `translateX(${currentTranslate}px)`;

    document.querySelectorAll(".feature-dot").forEach((dot, idx) => {
      dot.classList.toggle("active", idx === index);
    });
  }
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
